import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function LookupTable(props) {
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "LookupTable",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LookupTable",
      "data-tidal-icon-meta": "miscellaneous",
      viewBox: "0 0 18 18",
      children: /* @__PURE__ */ jsx("path", { d: "M16 4H6C4.9 4 4 4.9 4 6V16C4 17.1 4.9 18 6 18H16C17.1 18 18 17.1 18 16V6C18 4.9 17.1 4 16 4ZM16 6V8H6V6H16ZM8 12V10H14V12H8ZM14 14V16H8V14H14ZM8 12H6V10H8V12ZM14 10H16V12H14V10ZM6 14H8V16H6V14ZM14 16V14H16V16H14ZM3 14H2C0.9 14 0 13.1 0 12V2C0 0.9 0.9 0 2 0H12C13.1 0 14 0.9 14 2V3H12V2H2V12H3V14Z" })
    }
  );
}
LookupTable.tidalIconMeta = {
  categories: "miscellaneous",
  name: "LookupTable"
};
validateTidalLicense();
export {
  LookupTable
};
//# sourceMappingURL=LookupTable.js.map
